function H2() {
    return (
        <main className='main'>
            <h2>Опис трудових функцій; професійні компетентності; знання, уміння та навички</h2>
            <table>
                <tr>
                    <td colSpan="3">
                        Г2 Емоційно-етична
                    </td>
                </tr>
                <tr className='bold'>
                    <td>Професійні компетентності (за трудовою дією або групою трудових дій)</td>
                    <td>Знання</td>
                    <td>Уміння та навички</td>
                </tr>
                <tr>
                    <td rowSpan="3">
                        Г2.1 Здатність до саморегуляції та толерантної взаємодії
                    </td>
                    <td>
                        Г2.1.31 Теорія емоційного інтелекту
                    </td>
                    <td>
                        Г2.1.У1 Керувати власними емоціями у професійній діяльності чи/або під час спілкування з іншими учасниками освітнього процесу
                    </td>
                </tr>
                <tr>
                    <td>
                        Г2.1.32 Техніки саморегуляції емоційного стану
                    </td>
                    <td>
                        Г2.1.У2 Використовувати способи самозбереження психічного здоров’я, усвідомлювати, контролювати і управляти власним емоційний станом
                    </td>
                </tr>
                <tr>

                    <td>
                        Г2.1.33 Толерантність та її сутнісні характеристики
                    </td>
                    <td>
                        Г2.1 УЗ Реагувати на прояви емоцій, толерантно взаємодіяти з усіма учасниками освітнього процесу
                    </td>
                </tr>
                <tr>
                    <td rowSpan="2">
                        Г2.2 Здатність до усвідомленої, конструктивної та екологічної взаємодії з учасниками освітнього процесу
                    </td>
                    <td>
                        Г2.2.31 Засади конструктивної та екологічної взаємодії
                    </td>
                    <td>
                        Г2.2.У1 Здійснювати управлінську діяльність незалежно від власних тендерних, релігійних чи соціальних поглядів та упереджень
                    </td>
                </tr>
                <tr>
                    <td>
                        Г2.2.32 Техніки усвідомленого та емпатійного слухання, ненасильницької комунікації
                    </td>
                    <td>
                        Г2.2.У2 Застосовувати в обговореннях освітніх, соціальних і життєвих проблем методики усвідомленого й емпатійного слухання та ненасильницької комунікації
                    </td>
                </tr>
            </table>
        </main>
    )
}

export {H2}